import Cookies from 'js-cookie'

import { getSession } from './sessionStorage'

// Window.analytics is declared globally by @dfds-frontend/tracking; narrow it here at the usage site.
type SegmentUser = { user: () => { anonymousId: () => string | null } }

export const getUserSegmentId = (): string | null => {
  const analytics = window.analytics as SegmentUser | undefined
  const segmentUserAvailable = analytics?.user !== undefined
  const getIdFromBrowser = (name: string) => {
    const lsItem = localStorage.getItem(name)?.replace(/['"]+/g, '') || null
    const cookie = Cookies.get(name) || null
    const id = lsItem || cookie
    return id
  }
  const anonymousUserId = segmentUserAvailable ? analytics!.user().anonymousId() : getIdFromBrowser('ajs_anonymous_id')
  return anonymousUserId ?? getSession()?.sessionId ?? null
}
